import { Padrao } from '../generic/padrao';

export class FiscalAnp extends Padrao{

    override idTab = 247;

    codigo: string
    descricao: string;
}
